import { getEditorString, getPointAfter, getRange } from '@udecode/plate';

export const isNextCharacterText = (editor) => {
  if (!editor.selection) return false;

  const nextChar = getEditorString(
    editor,
    getRange(editor, editor.selection, getPointAfter(editor, editor.selection))
  );

  return nextChar !== '' && !/\s/.test(nextChar);
};
